module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Mobile.dd33c6af.png";